export default __webpack_public_path__ + "static/media/008-Doctor Strange.31e94757.svg";